export default __webpack_public_path__ + "static/media/current.45049e59.jpg";